import { useEffect } from 'react';
import GrupoArticulosForm from '../../components/grupos-articulos/GrupoArticulosForm';
import {
  useGrupoArticulosStore,
  type RegistrarGrupoArticulos
} from '../../stores/grupos-articulos/grupos-articulos.store';

const AgregarGrupoArticulos = () => {
  const { current: grupo, nuevo, registrar } = useGrupoArticulosStore((state) => state);

  useEffect(() => {
    nuevo();
  }, [nuevo]);

  const handleSave = (values: RegistrarGrupoArticulos) => {
    return registrar(values);
  };

  return <GrupoArticulosForm esAgregar={true} grupo={grupo} onSave={handleSave} />;
};

export default AgregarGrupoArticulos;
